export default (...reducers) =>
  (state, action) =>
    reducers.reduceRight((nextState, reducer) => reducer(nextState, action), state);
